import { DisciplinePage } from '../../../shared/components/DisciplinePage';
import { PlaceholderPanel } from '../../../shared/components/PlaceholderPanel';
import { useI18n } from '../../../../i18n';

export function ReputationPage() {
  const { t } = useI18n();
  return (
    <DisciplinePage
      accentColor="#0E243E"
      disciplineKey="reputation"
      disciplineTitle={t.sidebar.pageTitle.reputation}
      tabs={[
        {
          key: 'news',
          label: t.reputation.tabs.news,
          component: <PlaceholderPanel title={t.reputation.tabs.news} />,
        },
        {
          key: 'surveys',
          label: t.reputation.tabs.surveys,
          component: <PlaceholderPanel title={t.reputation.tabs.surveys} />,
        },
        {
          key: 'events',
          label: t.reputation.tabs.events,
          component: <PlaceholderPanel title={t.reputation.tabs.events} />,
        },
      ]}
    />
  );
}
